import React, { useContext, useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import IconButton from '@material-ui/core/IconButton';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Button from '@material-ui/core/Button';
import { unsubscribeRealtimeUpdates } from '../../system/firebase';
import { AppContext, LayoutContext } from '../../common/contexts';
import { setClassNameInDefns } from '../../common/definitionHelper';
import { CALENDAR_TYPE_MONTH, CALENDAR_TYPE_WEEK, CALENDAR_HOUR_HEIGHT, /*CALENDAR_WEEKLY_HOURS_HEIGHT,*/ INTERVIEW_STATUS_CONFIRMED } from '../../common/constants';
import startOfWeek from 'date-fns/startOfWeek';
import subWeeks from 'date-fns/subWeeks';
import addWeeks from 'date-fns/addWeeks';
import format from 'date-fns/format';
import isEqual from 'date-fns/isEqual';
import startOfDay from 'date-fns/startOfDay';
import endOfDay from 'date-fns/endOfDay';
import areIntervalsOverlapping from 'date-fns/areIntervalsOverlapping';
import isWithinInterval from 'date-fns/isWithinInterval';
import _get from 'lodash/get';
import _filter from 'lodash/filter';
import cx from 'clsx';
import SimpleBar from 'simplebar-react';
import 'simplebar/dist/simplebar.min.css';
import { loadCurrentWeekInterviewsByUserId } from '../../common/services/myCalendarServices';
import { createWeeklyCalendarData } from '../../common/calendarHelper';
import HoursColumn from './HoursColumn';

// const userId = 'ekOVkRuQj1evtfnLsoHVfyeia632';

const styles = theme => ({
    root: {
        backgroundColor: '#FFFFFF',
        height: '100%',
    },
    weeklyCalendar: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        // height: '82vh',
    },
    header: {
        background: '#FFFFFF',
        display: 'flex',
    },
    headerLeft: {
        flexGrow: 3,
        padding: '24px',
        display: 'flex',
        alignItems: 'center',
        [theme.breakpoints.down('sm')]: { padding: '24px 0px 24px 10px' },
    },
    headerRight: {
        display: 'flex',
        flexGrow: 1,
        justifyContent: 'flex-end',
    },
    keyboardArrowLeftIcon: {
        fontSize: '32px',
        backgroundColor: 'rgba(0, 0, 0, 0.03)',
        padding: '3px',
        borderRadius: '50%',
    },
    keyboardArrowRightIcon: {
        fontSize: '32px',
        backgroundColor: 'rgba(0, 0, 0, 0.03)',
        padding: '3px',
        borderRadius: '50%',
    },
    keyboardArrowLeftIconButton: {
        padding: 0,
        color: '#111E14',
    },
    keyboardArrowRightIconButton: {
        padding: 0,
        color: '#111E14',
        marginLeft: '8px',
    },
    month: {
        fontSize: '18px',
        color: '#111E14',
        fontWeight: 600,
        marginLeft: '16px',
        lineHeight: '32px',
        [theme.breakpoints.down('sm')]: { marginLeft: 6 },
    },
    year: {
        fontSize: '18px',
        color: '#9B9E9C',
        marginLeft: '5px',
        lineHeight: '32px',
    },
    scrollableContainer: {
        paddingRight: '15px',
        overflowY: 'scroll',
    },
    dayContainerHeader: {
        display: 'flex',
        borderTop: '1px solid #F0F0F0',
        borderBottom: '1px solid #F0F0F0',
        paddingBottom: '2px',
    },
    dayContainer: {
        display: 'flex',
    },
    dayContainer2: {
        display: 'flex',
        //height: `${CALENDAR_WEEKLY_HOURS_HEIGHT}px`,
    },
    dayColumn: {
        flex: '1 1 auto',
        borderRight: '1px solid #F0F0F0',
    },
    dayColumnEnd: {
        flex: '1 1 auto',
    },
    dayColumnLabel: {
        flex: '1 1 0px',
        color: '#9B9E9C',
        fontSize: '12px',
        justifyContent: 'center',
        alignItems: 'center',
    },
    dayColumnNumber: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    dayColumnLabelEnd: {
        flex: '1 1 0px',
        color: '#9B9E9C',
        fontSize: '12px',
        justifyContent: 'center',
        alignItems: 'center',
    },
    dayColumnHoursLabel: {
        width: '50px',
        borderRight: '1px solid #F0F0F0',
        color: '#9B9E9C',
        fontSize: '12px',
        marginTop: '-10px',
    },
    dayColumnHoursTimeZoneLabel: {
        width: '50px',
        color: '#9B9E9C',
        fontSize: '12px',
        alignSelf: 'flex-end',
        justifyContent: 'center',
    },
    hour: {
        borderBottom: '1px solid #F0F0F0',
        minHeight: '46px',
    },
    hourEnd: {
        borderBottom: '1px solid #F0F0F0',
        minHeight: '46px',
    },
    hoursLabel: {
        minHeight: `${CALENDAR_HOUR_HEIGHT + 1}px`,
    },
    hoursLabelEnd: {
        minHeight: `${CALENDAR_HOUR_HEIGHT + 1}px`,
    },
    monthWeekButtonGroupContainer: {
        padding: '24px 24px 24px 0px',
        [theme.breakpoints.down('sm')]: { padding: '24px 16px 24px 0px' },
    },
    monthWeekButtonGroup: {
        '& :not(:last-child)': {
            borderRight: 'none',
        },
    },
    monthWeekButtons: {
        background: '#1D8A8B',
        color: '#FFF',
        '&:hover': {
            backgroundColor: '#E0E1E5',
            color: '#000',
        },
    },
    monthWeekButtonOff: {
        background: 'rgba(0, 0, 0, 0.03)',
        color: '#111E14',
    },
    selectedDay: {
        background: '#1D8A8B',
        color: '#FFFFFF',
        borderRadius: '14px',
        width: '20px',
        height: '20px',
        minWidth: '20px',
        lineHeight: '20px',
    },
    today: {
        background: '#CDBFBF',
        color: '#FFFFFF',
        borderRadius: '14px',
        width: '20px',
        height: '20px',
        minWidth: '20px',
        lineHeight: '20px',
    },
    simpleBarContainer: {
        height: '80%',
        [theme.breakpoints.down('lg')]: { height: '70%' },
        [theme.breakpoints.down('md')]: { height: '60%' },
    },
});

const getDefns = params => {
    const { props, calendarType, setCalendarType, calendarData, setFirstDayOfWeek, interviewList, selectedDate } = params;
    const {
        classes,
        classes: { monthWeekButtons: monthWeekButtonsCls, monthWeekButtonOff: monthWeekButtonOffCls },
    } = props;

    let monthButtonClassNames = [monthWeekButtonsCls];
    if (calendarType !== CALENDAR_TYPE_MONTH) monthButtonClassNames.push(monthWeekButtonOffCls);
    let weekButtonClassNames = [monthWeekButtonsCls];
    if (calendarType !== CALENDAR_TYPE_WEEK) weekButtonClassNames.push(monthWeekButtonOffCls);

    const today = startOfDay(new Date());

    const defns = {
        keyboardArrowLeftIconButton: {
            onClick: () => {
                setFirstDayOfWeek(subWeeks(calendarData.day0, 1));
            },
        },
        keyboardArrowRightIconButton: {
            onClick: () => {
                setFirstDayOfWeek(addWeeks(calendarData.day0, 1));
            },
        },
        monthWeekButtonGroup: { disableElevation: true },
        monthButton: {
            className: cx(monthButtonClassNames),
            onClick: setCalendarType.bind(null, CALENDAR_TYPE_MONTH),
        },
        weekButton: {
            className: cx(weekButtonClassNames),
            onClick: setCalendarType.bind(null, CALENDAR_TYPE_WEEK),
        },
        day0: {
            day: calendarData.day0,
            interviewList: _filter(interviewList, item => {
                const inRange = areIntervalsOverlapping(
                    { start: _get(item, 'startDt').toDate(), end: _get(item, 'endDt').toDate() },
                    { start: calendarData.day0, end: endOfDay(calendarData.day0) },
                );

                return inRange;
            }),
            selected: isEqual(startOfDay(selectedDate), calendarData.day0),
            today: isEqual(startOfDay(today), calendarData.day0),
        },
        day1: {
            day: calendarData.day1,
            interviewList: _filter(interviewList, item => {
                const inRange = areIntervalsOverlapping(
                    { start: _get(item, 'startDt').toDate(), end: _get(item, 'endDt').toDate() },
                    { start: calendarData.day1, end: endOfDay(calendarData.day1) },
                );

                return inRange;
            }),
            selected: isEqual(startOfDay(selectedDate), calendarData.day1),
            today: isEqual(startOfDay(today), calendarData.day1),
        },
        day2: {
            day: calendarData.day2,
            interviewList: _filter(interviewList, item => {
                const inRange = areIntervalsOverlapping(
                    { start: _get(item, 'startDt').toDate(), end: _get(item, 'endDt').toDate() },
                    { start: calendarData.day2, end: endOfDay(calendarData.day2) },
                );

                return inRange;
            }),
            selected: isEqual(startOfDay(selectedDate), calendarData.day2),
            today: isEqual(startOfDay(today), calendarData.day2),
        },
        day3: {
            day: calendarData.day3,
            interviewList: _filter(interviewList, item => {
                const inRange = areIntervalsOverlapping(
                    { start: _get(item, 'startDt').toDate(), end: _get(item, 'endDt').toDate() },
                    { start: calendarData.day3, end: endOfDay(calendarData.day3) },
                );

                return inRange;
            }),
            selected: isEqual(startOfDay(selectedDate), calendarData.day3),
            today: isEqual(startOfDay(today), calendarData.day3),
        },
        day4: {
            day: calendarData.day4,
            interviewList: _filter(interviewList, item => {
                const inRange = areIntervalsOverlapping(
                    { start: _get(item, 'startDt').toDate(), end: _get(item, 'endDt').toDate() },
                    { start: calendarData.day4, end: endOfDay(calendarData.day4) },
                );

                return inRange;
            }),
            selected: isEqual(startOfDay(selectedDate), calendarData.day4),
            today: isEqual(startOfDay(today), calendarData.day4),
        },
        day5: {
            day: calendarData.day5,
            interviewList: _filter(interviewList, item => {
                const inRange = areIntervalsOverlapping(
                    { start: _get(item, 'startDt').toDate(), end: _get(item, 'endDt').toDate() },
                    { start: calendarData.day5, end: endOfDay(calendarData.day5) },
                );

                return inRange;
            }),
            selected: isEqual(startOfDay(selectedDate), calendarData.day5),
            today: isEqual(startOfDay(today), calendarData.day5),
        },
        day6: {
            day: calendarData.day6,
            interviewList: _filter(interviewList, item => {
                const inRange = areIntervalsOverlapping(
                    { start: _get(item, 'startDt').toDate(), end: _get(item, 'endDt').toDate() },
                    { start: calendarData.day6, end: endOfDay(calendarData.day6) },
                );

                return inRange;
            }),
            selected: isEqual(startOfDay(selectedDate), calendarData.day6),
            today: isEqual(startOfDay(today), calendarData.day6),
        },
    };

    setClassNameInDefns(defns, classes);

    return defns;
};

const getDayColumnNumber = params => {
    const { props, day, selected, today } = params;

    const {
        classes: { dayColumnNumber: dayColumnNumberCls, selectedDay: selectedDayCls, today: todayCls },
    } = props;

    let dayClassName;

    if (selected === true) {
        dayClassName = selectedDayCls;
    } else if (today === true) {
        dayClassName = todayCls;
    }

    return (
        <div className={dayColumnNumberCls}>
            <div className={dayClassName}>{format(day, 'd')}</div>
        </div>
    );
};

const WeeklyCalendar = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    const appContext = useContext(AppContext);
    const context = useContext(LayoutContext);
    const userId = _get(appContext, 'authUser.uid');
    const calendarType = _get(context, 'calendarType');
    const setCalendarType = _get(context, 'setCalendarType');
    const selectedDate = _get(context, 'selectedDate');
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Local states
    const [firstDayOfWeek, setFirstDayOfWeek] = useState(startOfWeek(new Date()));
    const [calendarData, setCalendarData] = useState(createWeeklyCalendarData(firstDayOfWeek));
    const [interviewList, setInterviewList] = useState([]);
    const [isCalendarScrolled, setIsCalendarScrolled] = useState(false);
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // From props
    const setConfirmedInterviewsCount = _get(props, 'setConfirmedInterviewsCount');
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Derived
    const timeZoneOffset = format(firstDayOfWeek, 'z');
    const scrollTo = ref => {
        if (ref && !isCalendarScrolled) {
            ref.scrollIntoView({ behavior: 'smooth', block: 'start' });
            setIsCalendarScrolled(true);
        }
    };
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Side effects
    useEffect(() => {
        const newCalendarData = createWeeklyCalendarData(firstDayOfWeek);
        setCalendarData(newCalendarData);

        const unsubscribeOnSnapshot = loadCurrentWeekInterviewsByUserId(userId, newCalendarData.day0, endOfDay(newCalendarData.day6), setInterviewList);

        // unsubscribe realtime update on unmount
        return () => {
            unsubscribeRealtimeUpdates([unsubscribeOnSnapshot]);
        };
    }, [userId, firstDayOfWeek]);

    useEffect(() => {
        // update confirmed interviews count only if selectedDate is in the current calendar (in case user navigated to a different week)
        const lastDayOfWeek = addWeeks(firstDayOfWeek, 1);

        if (isWithinInterval(selectedDate, { start: firstDayOfWeek, end: lastDayOfWeek })) {
            const interviewsOnSelectedDate = _filter(interviewList, data => {
                const startDt = _get(data, 'startDt');
                const startDtStartOfDay = startDt ? startOfDay(startDt.toDate()) : null;
                const isSelectedDateEqualToInterviewDate = isEqual(startDtStartOfDay, selectedDate);

                return isSelectedDateEqualToInterviewDate && _get(data, 'status') === INTERVIEW_STATUS_CONFIRMED;
            });

            setConfirmedInterviewsCount(interviewsOnSelectedDate.length);
        }
    }, [selectedDate, firstDayOfWeek, calendarData, interviewList, setConfirmedInterviewsCount]);

    useEffect(() => {
        // The useEffect is only called when this component is first loaded,
        // so set isCalendarScrolled to false so the calendar will scroll
        // only when this is first loaded, and not when the user is scrolling
        // through the weeks.
        setIsCalendarScrolled(false);
    }, []);
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Defns
    const defns = getDefns({
        props,
        calendarType,
        setCalendarType,
        calendarData,
        setFirstDayOfWeek,
        interviewList,
        selectedDate,
    });
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Render
    return (
        <LayoutContext.Provider value={{ calendarData, /*setInterviewCardAnchorEl, clickedInterviewId, setClickedInterviewId,*/ ...context }}>
            <div {...defns.root}>
                <div {...defns.weeklyCalendar}>
                    <div {...defns.header}>
                        <div {...defns.headerLeft}>
                            <div>
                                <IconButton {...defns.keyboardArrowLeftIconButton}>
                                    <KeyboardArrowLeftIcon {...defns.keyboardArrowLeftIcon} />
                                </IconButton>
                                <IconButton {...defns.keyboardArrowRightIconButton}>
                                    <KeyboardArrowRightIcon {...defns.keyboardArrowRightIcon} />
                                </IconButton>
                            </div>

                            <div {...defns.month}>{format(calendarData.day0, 'MMMM')}</div>
                            <div {...defns.year}>{format(calendarData.day0, 'yyyy')}</div>
                        </div>
                        <div {...defns.headerRight}>
                            <div {...defns.monthWeekButtonGroupContainer}>
                                <ButtonGroup variant="contained" aria-label="contained button group" {...defns.monthWeekButtonGroup}>
                                    <Button {...defns.monthButton}>Month</Button>
                                    <Button {...defns.weekButton}>Week</Button>
                                </ButtonGroup>
                            </div>
                        </div>
                    </div>
                    <div {...defns.dayContainerHeader}>
                        <div {...defns.dayColumnHoursTimeZoneLabel}>
                            <div>&nbsp;</div>
                            <div>{timeZoneOffset}</div>
                        </div>
                        <div {...defns.dayColumnLabel}>
                            <div>SUN</div>
                            {getDayColumnNumber({ props, ...defns.day0 })}
                        </div>
                        <div {...defns.dayColumnLabel}>
                            <div>MON</div>
                            {getDayColumnNumber({ props, ...defns.day1 })}
                        </div>
                        <div {...defns.dayColumnLabel}>
                            <div>TUE</div>
                            {getDayColumnNumber({ props, ...defns.day2 })}
                        </div>
                        <div {...defns.dayColumnLabel}>
                            <div>WED</div>
                            {getDayColumnNumber({ props, ...defns.day3 })}
                        </div>
                        <div {...defns.dayColumnLabel}>
                            <div>THU</div>
                            {getDayColumnNumber({ props, ...defns.day4 })}
                        </div>
                        <div {...defns.dayColumnLabel}>
                            <div>FRI</div>
                            {getDayColumnNumber({ props, ...defns.day5 })}
                        </div>
                        <div {...defns.dayColumnLabelEnd}>
                            <div>SAT</div>
                            {getDayColumnNumber({ props, ...defns.day6 })}
                        </div>
                    </div>
                    {/*<SimpleBar style={{ height: '100%' }} scrollableNodeProps={{ ref: scrollableNodeRef }}>*/}
                    <SimpleBar {...defns.simpleBarContainer}>
                        <div {...defns.dayContainer2}>
                            <div {...defns.dayColumnHoursLabel}>
                                <div {...defns.hoursLabel}></div>
                                <div {...defns.hoursLabel}>1 AM</div>
                                <div {...defns.hoursLabel}>2 AM</div>
                                <div {...defns.hoursLabel}>3 AM</div>
                                <div {...defns.hoursLabel}>4 AM</div>
                                <div {...defns.hoursLabel}>5 AM</div>
                                <div {...defns.hoursLabel}>6 AM</div>

                                <div {...defns.hoursLabel} ref={scrollTo}>
                                    7 AM
                                </div>

                                <div {...defns.hoursLabel}>8 AM</div>
                                <div {...defns.hoursLabel}>9 AM</div>
                                <div {...defns.hoursLabel}>10 AM</div>
                                <div {...defns.hoursLabel}>11 AM</div>
                                <div {...defns.hoursLabel}>12 PM</div>
                                <div {...defns.hoursLabel}>1 PM</div>
                                <div {...defns.hoursLabel}>2 PM</div>
                                <div {...defns.hoursLabel}>3 PM</div>
                                <div {...defns.hoursLabel}>4 PM</div>
                                <div {...defns.hoursLabel}>5 PM</div>
                                <div {...defns.hoursLabel}>6 PM</div>
                                <div {...defns.hoursLabel}>7 PM</div>
                                <div {...defns.hoursLabel}>8 PM</div>
                                <div {...defns.hoursLabel}>9 PM</div>
                                <div {...defns.hoursLabel}>10 PM</div>
                                <div {...defns.hoursLabelEnd}>11 PM</div>
                            </div>
                            <HoursColumn {...defns.day0} />
                            <HoursColumn {...defns.day1} />
                            <HoursColumn {...defns.day2} />
                            <HoursColumn {...defns.day3} />
                            <HoursColumn {...defns.day4} />
                            <HoursColumn {...defns.day5} />
                            <HoursColumn {...defns.day6} />
                        </div>
                    </SimpleBar>
                </div>
            </div>
            {/* <InterviewCard {...defns.interviewCard} /> */}
        </LayoutContext.Provider>
    );
    //---------------------------------------------------------------------
};

export default withStyles(styles)(WeeklyCalendar);
